import React from 'react'
import { Box, Typography, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const Footer: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box component="footer" sx={{ py: 3, px: 2, mt: 'auto', borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap' }}>
        <Link component={RouterLink} to="/legal" variant="caption" color="text.secondary" underline="hover">
          {t('legal.footer.legalNotice')}
        </Link>
        <Link component={RouterLink} to="/privacy" variant="caption" color="text.secondary" underline="hover">
          {t('legal.footer.privacy')}
        </Link>
        <Link component={RouterLink} to="/terms" variant="caption" color="text.secondary" underline="hover">
          {t('legal.footer.terms')}
        </Link>
        <Link component={RouterLink} to="/cookies" variant="caption" color="text.secondary" underline="hover">
          {t('legal.footer.cookies')}
        </Link>
      </Box>
      <Typography variant="caption" color="text.disabled" sx={{ display: 'block', textAlign: 'center', mt: 1 }}>
        © {new Date().getFullYear()} Moni Ventures SL
      </Typography>
    </Box>
  )
}
